import logo from './logo.svg';
// import './App.css';
import { Route, Switch, Link } from "react-router-dom";
import { Nav, NavItem, NavLink, Navbar, Container, Row, Col } from 'reactstrap';
import Task from './components/task';
import Score from './components/score';
import Home from './components/home';

const App = () => {
  return (
    <main className="bg-light vh-100">

      <Navbar color="dark" dark>

        <Nav>
          <NavItem>
            <NavLink>
              <Link to="/">Home</Link>
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink>
              <Link to="/task">Task</Link>
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink>
              <Link to="/score">Score</Link>
            </NavLink>
          </NavItem>
        </Nav>
      </Navbar>

      <Container>
        <Row className="justify-content-center">


          <Switch>
            <Route path="/" component={Home} exact />
            <Route path="/task" component={Task} />
            <Route path="/score" component={Score} />
          </Switch>


        </Row>
      </Container>
    </main>

  );
}

export default App;
